import * as React from 'react';

interface IProps {
	text: string;
	href?: string;
	onClick?: () => void;
	className?: string;
	icon?: string;
	animate?: boolean;
	target?: string;
}

const Button = ({
	text,
	href,
	onClick,
	className = '',
	icon = '',
	animate = true,
	target,
}: IProps) => {
	const words = text.trim().split(/\s+/);
	const wordCount = words.length;

	const buttonClasses = `${className}`.trim();
	const ariaLabel = animate && words.length > 0 ? text : undefined;

	const renderWords = () => {
		if (!animate || words.length === 0) {
			return text;
		}

		return (
			<span className="btn-inner">
				{words.map((word, index) => (
					<React.Fragment key={index}>
						<span
							className="btn-words"
							style={
								{
									'--word-index': index + 1,
									'--word-count': wordCount,
								} as React.CSSProperties
							}
						>
							<span className="btn-words__visible">{word}</span>
							<span className="btn-words__clone">{word}</span>
						</span>
						{index < words.length - 1 && ' '}
					</React.Fragment>
				))}
			</span>
		);
	};

	const content = (
		<>
			{renderWords()}
			{icon && <span className={icon}></span>}
		</>
	);

	if (href) {
		return (
			<a
				href={href}
				className={buttonClasses}
				target={target}
				aria-label={ariaLabel}
				rel={target === '_blank' ? 'noopener noreferrer' : undefined}
			>
				{content}
			</a>
		);
	}

	return (
		<button className={buttonClasses} aria-label={ariaLabel} onClick={onClick}>
			{content}
		</button>
	);
};

Button.displayName = 'Button';

export default Button;
